import { PartialTranslation } from '../translations';

export const tr: PartialTranslation = {
  newChat: 'Yeni Sohbet',
  search: 'Ara',
  user: 'Kullanıcı',
  settings: 'Ayarlar',
  language: 'Dil',
  getHelp: 'Yardım al',
  viewAllPlans: 'Tüm planları görüntüle',
  learnMore: 'Daha fazla öğren',
  logOut: 'Çıkış yap',
  chooseLanguage: 'Dil Seç',
  chooseYourPreferredLanguage: 'Tercih ettiğiniz dili seçin',
  searchLanguages: 'Dil ara...',
  autoDetect: 'Otomatik Algılama',
  noLanguagesFound: 'Dil bulunamadı',
  askAnything: 'Her şeyi sor',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Kişisel',
  freePlan: 'Ücretsiz plan',
  current: 'Şu anki',
  close: 'Kapat',
  archive: 'Arşivle',
  delete: 'Sil',
  confirmDelete: 'Bu sohbeti silmek istediğinizden emin misiniz?',
  confirmArchive: 'Bu sohbeti arşivlemek istediğinizden emin misiniz?',
  deleteCannotUndo: 'Bu işlem geri alınamaz.',
  archiveCanFind: 'Arşivledikten sonra arşiv listesinde bulabilirsiniz.',
  
  // 资源面板
  resources: 'Kaynaklar',
  addResource: 'Kaynak ekle',
  deleteResource: 'Kaynak sil',
  noMatchingResourcesFound: 'Eşleşen kaynak bulunamadı',
  noResourcesAvailable: 'Mevcut kaynak yok',
  hideResources: 'Kaynakları gizle',
  showResources: 'Kaynakları göster',
  
  // 聊天输入框
  typeMessage: 'Mesaj yazın...',
  thinkingOptions: 'Düşünme seçenekleri',
  deleteFile: 'Dosya sil',
  clearSelection: 'Seçimi temizle',
  addAttachment: 'Ek ekle',
  sendMessage: 'Mesaj gönder',
  
  // 思考模式选项
  deepInsight: 'Derin İçgörü · Yüzeysel Analiz',
  deepInsightDesc: 'Anahtar noktaları hızlı anlama',
  deepExploration: 'Derin Keşif · Kapsamlı Analiz',
  deepExplorationDesc: 'Çok boyutlu derinlemesine araştırma',
  deepDeconstruction: 'Derin Yapı Bozumu · Sistematik Argüman',
  deepDeconstructionDesc: 'Katman katman ilerleyici analiz',
  
  // 写作模式选项
  contractReview: 'Sözleşme İncelemesi · Risk Tanımlama',
  contractReviewDesc: 'Madde analizi ve uyumluluk kontrolü',
  textPolish: 'Metin Cilalama · Profesyonel İfade',
  textPolishDesc: 'Dil optimizasyonu ve yapı ayarlaması',
  legalDocuments: 'Hukuki Belgeler · Standart Taslak',
  legalDocumentsDesc: 'Profesyonel hukuki belge yazımı',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Giriş Yap',
  register: 'Kayıt Ol',
  welcomeBack: 'LawHelper\'a Hoş Geldiniz',
  loginSubtitle: 'AI Hukuk Araştırma Asistanınız',
  continueWithGoogle: 'Google ile Devam Et',
  continueWithMicrosoft: 'Microsoft ile Devam Et',
  continueWithWeChat: 'WeChat ile Devam Et',
  orContinueWith: 'veya şununla devam et',
  emailTab: 'E-posta',
  phoneTab: 'Telefon',
  emailPlaceholder: 'E-postanızı girin',
  phonePlaceholder: 'Telefon numaranızı girin',
  codePlaceholder: '6 haneli kodu girin',
  sending: 'Gönderiliyor...',
  verifying: 'Doğrulanıyor...',
  verify: 'Doğrula',
  sendMagicLink: 'Sihirli Bağlantı Gönder',
  getVerificationCode: 'Kod Al',
  resendCode: 'Kodu Tekrar Gönder',
  resendIn: 'Tekrar gönder:',
  magicLinkSent: 'Sihirli bağlantı e-postanıza gönderildi',
  magicLinkHint: 'E-postanıza güvenli bir bağlantı göndereceğiz',
  otpSent: 'Doğrulama kodu gönderildi',
  agreeToTerms: 'Devam ederek kabul etmiş olursunuz',
  privacyPolicy: 'Gizlilik Politikası',
  termsOfService: 'Hizmet Şartları',
  and: 've',
  privacyTitle: 'Gizliliğiniz Önemli',
  privacyIntro: 'Size en iyi deneyimi sunmak için çerezler ve benzer teknolojiler kullanıyoruz.',
  essentialCookies: 'Temel Çerezler',
  essentialDesc: 'Web sitesinin çalışması için gerekli',
  analyticsCookies: 'Analiz Çerezleri',
  analyticsDesc: 'Hizmetimizi geliştirmemize yardımcı olur',
  marketingCookies: 'Pazarlama Çerezleri',
  marketingDesc: 'Kişiselleştirilmiş içerik için kullanılır',
  acceptAll: 'Tümünü Kabul Et',
  essentialOnly: 'Yalnızca Temel',
  customize: 'Özelleştir',
  savePreferences: 'Tercihleri Kaydet',
  back: 'Geri',
  readPrivacyPolicy: 'Gizlilik politikamızı okuyun',
  cookiePolicy: 'Çerez Politikası',
  gdprCompliance: 'KVKK/GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI İnceleme',
  aiDraft: 'AI Taslak',
  smartAssistant: 'Şablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Aramayı etkinleştir',
  knowledgeSearchDesc: 'AI belgelerinizde arar',
  clickToDisable: 'Devre dışı',
  clickToEnable: 'Etkinleştir',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Kaynak panelini kapat',
  uploading: '%{fileName} yükleniyor...',
  processing: '%{fileName} işleniyor...',
  uploadSuccess: '✓ %{fileName} yüklendi',
  uploadError: '✗ Yükleme başarısız: %{error}',
  quickAnswer: 'Hızlı Yanıt',
  quickAnswerDesc: 'Basit sorulara hızlı yanıt',
  cancelRequest: 'İptal',
  library: 'Kütüphane',
  filterAll: 'Tümü',
  filterChat: 'Sohbetler',
  filterReview: 'İnceleme',
  filterDraft: 'Taslak',
  filterTemplate: 'Şablon',
  filterForm: 'Form',
  thinking: 'Düşünüyor...',
  thinkingProcess: 'Düşünme süreci',
  analyzingLegalLogic: 'Hukuki mantık analiz ediliyor...',
  lawhelperThinking: 'Lawhelper düşünüyor...',
  serviceError: 'Servis hatası',
  uploaded: 'Yüklendi',
  settingsGeneral: 'Genel',
  settingsNotifications: 'Bildirimler',
  settingsAppearance: 'Görünüm',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Yanıt bildirimleri',
  settingsResponseNotificationsDesc: 'AI yanıt tamamlandığında bildirim',
  settingsColorMode: 'Renk modu',
  settingsLight: 'Açık',
  settingsDark: 'Koyu',
  settingsSystem: 'Sistem',
  about: 'Hakkında',
  reviewTitle: 'Belge incelemesi',
  exitReview: 'İncelemeden çık',
  uploadPrompt: 'İnceleme için PDF yükleyin',
  uploadButton: 'Dosya seç',
  startChatConfig: '"Bu belgeyi incele" yazın',
  reviewPlaceholder: 'Mesaj yazın...',
  analyzing: 'İnceleniyor...',
  reviewComplete: 'İnceleme tamamlandı',
  issuesFound: '%{count} sorun bulundu',
  draftTitle: 'Hukuki belge hazırlama',
  draftPlaceholder: 'Burada düzenleyin veya AI den isteyin...',
  analyzingTemplate: 'Şablon %{name} analiz ediliyor...',
  templateAnalyzed: '✅ Şablon %{name} analiz edildi!',
  templateAnalysisPrompt: 'Anahtar maddeleri analiz et',
  parsingFailed: '⚠️ Dosya analiz edilemedi.',
  generating: 'Oluşturuluyor...',
  generatedSuccess: '✅ Belge oluşturuldu!',
  drafterWelcome: 'AI Belge Asistanına hoş geldiniz',
  drafterYouCan: 'Şunları yapabilirsiniz:',
  drafterUploadTemplate: 'AI analizi için şablon yükle',
  drafterDescribeNeeds: 'Belge gereksinimlerini tanımla',
  drafterLetAiHelp: 'AI sözleşme ve anlaşma hazırlamada yardımcı olur',
  drafterExamples: 'Örnekler:',
  drafterExampleRental: '"Kira sözleşmesi hazırla"',
  drafterExampleLabor: '"İş sözleşmesini doldur"',
  drafterInputPlaceholder: 'İhtiyaçlarınızı tanımlayın...',
  drafterThinking: 'Düşünüyor...',
  drafterHistoryTitle: 'Geçmiş',
  drafterNoHistory: 'Geçmiş yok',
  drafterNewChat: 'Yeni sohbet',
  drafterHistory: 'Geçmiş',
  drafterRemoveAttachment: 'Eki kaldır',
  drafterLineHeight: 'Satır yüksekliği',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Word olarak dışa aktar (.docx)',
  drafterExportPdf: 'PDF olarak dışa aktar',
  drafterSave: 'Belgeyi kaydet',
  drafterDownload: 'Belgeyi indir',
  drafterUndo: 'Geri al',
  drafterRedo: 'Yinele',
  drafterBold: 'Kalın',
  drafterItalic: 'İtalik',
  drafterStrike: 'Üstü çizili',
  drafterUnderline: 'Altı çizili',
  drafterHighlight: 'Vurgula',
  drafterLink: 'Bağlantı ekle',
  drafterAlignLeft: 'Sola hizala',
  drafterAlignCenter: 'Ortala',
  drafterAlignRight: 'Sağa hizala',
  drafterAlignJustify: 'İki yana yasla',
  drafterList: 'Liste',
  drafterBulletList: 'Madde işareti',
  drafterOrderedList: 'Numaralı liste',
  drafterTaskList: 'Görev listesi',
  drafterOpenResource: 'Kaynakları aç',
  drafterStopGeneration: 'Oluşturmayı durdur',
  drafterAgentMode: 'Ajan modu aktif',
  drafterAgentModeOn: 'Ajan modu aktif',
  drafterAgentModeOff: 'Normal mod',
  drafterUploadAttachment: 'Ek yükle',
  drafterExit: 'Çık',
  drafterConfirm: 'Onayla',
  drafterOpenLink: 'Bağlantıyı aç',
  drafterDeleteLink: 'Bağlantıyı sil',
  drafterQuote: 'Alıntı',
  workflowTitle: 'AI iş akışı',
  workflowRunning: 'Çalışıyor...',
  workflowReady: 'Hazır',
  workflowCompleted: 'Tamamlandı',
  workflowStartFailed: 'İş akışı başlatma başarısız',
  workflowExecutionFailed: 'İş akışı yürütme başarısız',
  workflowInterrupted: 'İş akışı kesildi',
  workflowProcessing: 'İşleniyor...',
  workflowStepsCompleted: 'adım tamamlandı',
  workflowStepsTotal: 'İş akışı tamamlandı (%{count} adım)',
  acceptChanges: 'Değişiklikleri kabul et',
  rejectChanges: 'Değişiklikleri reddet',
  changesAccepted: 'Değişiklikler kabul edildi',
  changesRejected: 'Değişiklikler reddedildi',
  stopWorkflow: 'Durdur',
  restartWorkflow: 'Yeniden başlat',
  startDrafting: 'Hazırlamaya başla',
  interrupt: 'Durdur',
  documentSubject: 'Belge konusu *',
  documentType: 'Belge türü',
  jurisdiction: 'Yargı yetkisi',
  specialRequirements: 'Özel gereksinimler (isteğe bağlı)',
  clickStartDrafting: '"Hazırlamaya başla" tıklayın',
  docTypeContract: 'Sözleşme',
  docTypeAgreement: 'Anlaşma',
  docTypeNotice: 'Bildirim',
  docTypeLetter: 'Mektup',
  docTypePetition: 'Dilekçe',
  docTypeWill: 'Vasiyetname',
  docTypePowerOfAttorney: 'Vekâletname',
  countryChina: 'Çin',
  countryUSA: 'ABD',
  countryGermany: 'Almanya',
  countryJapan: 'Japonya',
  countryFrance: 'Fransa',
  countryUK: 'Birleşik Krallık',
  citationVerified: 'Doğrulandı',
  citationUnverified: 'Doğrulanmadı',
  imageLoadFailed: 'Resim yüklenemedi',
  smartDocTitle: 'Akıllı belge asistanı',
  smartDocChatTitle: 'AI belge asistanı',
  smartDocDropPrompt: 'PDF dosyasını buraya bırakın',
  smartDocSelectFile: 'Dosya seç',
  smartDocOr: 'veya',
  smartDocWelcomeTitle: 'AI Belge Asistanına hoş geldiniz',
  smartDocWelcomeYouCan: 'Şunları yapabilirsiniz:',
  smartDocUploadForAI: 'Şablon yükle',
  smartDocDescribeDoc: 'Gereksinimleri tanımla',
  smartDocLetAIDraft: 'AI sözleşmelerde yardımcı olur',
  smartDocExamples: 'Örnekler:',
  smartDocExampleRental: '"Kira sözleşmesi hazırla"',
  smartDocExampleLabor: '"İş sözleşmesini doldur"',
  smartDocInputPlaceholder: 'İhtiyaçlarınızı tanımlayın...',
  smartDocRemoveAttachment: 'Eki kaldır',
  smartDocOpenResources: 'Kaynakları aç',
  smartDocExit: 'Çık',
  reviewStartFailed: 'İnceleme başlatma başarısız',
  reviewFailed: 'İnceleme başarısız',
  reviewFoundIssues: 'İnceleme tamamlandı, %{count} sorun.',
  cannotReadStream: 'Yanıt akışı okunamıyor',
  parseEventFailed: 'Olay analiz edilemedi',
  errorPrefix: 'Hata',
  unknownError: 'Bilinmeyen hata',
  file: 'Dosya',
  loading: 'Yükleniyor...',
  localFolders: 'Yerel klasörler',
  selectLocalFolder: 'Yerel klasör seç',
  reselectFolder: 'Klasörü değiştir',
  addToContext: 'Sohbete ekle',
  saveFile: 'Kaydet',
  renameFile: 'Yeniden adlandır',
  fileSaved: 'Dosya kaydedildi',
  fileRenamed: 'Dosya %{name} olarak yeniden adlandırıldı',
  browserNotSupported: 'Tarayıcınız yerel klasör erişimini desteklemiyor',
  noFolderSelected: 'Dosyaları görmek için yerel klasör seçin',
  scanningFolder: 'Klasör taranıyor...',
  selectFileToPreview: 'Önizleme için dosya seçin',
  aiAnalyze: 'AI analiz',
};
